'use strict';

var React = require('react');

var SvgTranslateMajor = function SvgTranslateMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.955 3.994a.75.75 0 0 0-1.41 0l-2 5.5a.75.75 0 1 0 1.41.512l.187-.514a.756.756 0 0 0 .108.008h2.111l.184.506a.75.75 0 1 0 1.41-.512l-2-5.5Zm-.705 2.45.566 1.556h-1.132l.566-1.555Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.55 7.75v-1a.25.25 0 0 0-.25-.25h-1.49l.22.22a.75.75 0 1 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06l1.5-1.5a.75.75 0 0 1 1.06 1.06l-.22.22h1.49c.966 0 1.75.783 1.75 1.75v1a.75.75 0 1 1-1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.25v1c0 .138.112.25.25.25h1.49l-.22-.22a.75.75 0 1 1 1.06-1.06l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 0 1-1.06-1.06l.22-.22h-1.49a1.75 1.75 0 0 1-1.75-1.75v-1a.75.75 0 1 1 1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.002 11.5h-.252a.75.75 0 0 1 0-1.5h1.75v-.25a.75.75 0 0 1 1.5 0v.25h1.75a.75.75 0 0 1 0 1.5h-.312a5.877 5.877 0 0 1-.4 1.945 5.13 5.13 0 0 1-.69 1.227c.293.161.634.3 1.03.402a.75.75 0 0 1-.376 1.452 5.676 5.676 0 0 1-1.782-.788 5.677 5.677 0 0 1-1.782.788.75.75 0 1 1-.376-1.452c.396-.103.737-.24 1.03-.402a5.115 5.115 0 0 1-.69-1.227 5.88 5.88 0 0 1-.4-1.945Zm2.935 0h-1.434a4.381 4.381 0 0 0 .295 1.394c.101.257.237.524.422.782.185-.258.32-.525.422-.782a4.386 4.386 0 0 0 .295-1.394Z"
  }));
};
SvgTranslateMajor.displayName = "TranslateMajor";

exports.SvgTranslateMajor = SvgTranslateMajor;
